import React from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { PlayerProvider } from './contexts/PlayerContext';
import { LibraryProvider } from './contexts/LibraryContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { useSeedPlaylists } from './hooks/useSeedPlaylists';
import { Sidebar } from './components/Sidebar';
import { MobileNav } from './components/MobileNav';
import { PlayerBar } from './components/PlayerBar';
import { AmbientBackdrop } from './components/AmbientBackdrop';
import { PageTransition } from './components/PageTransition';
import { Home } from './pages/Home';
import { Search } from './pages/Search';
import { Library } from './pages/Library';
import { Playlist } from './pages/Playlist';
import { NowPlaying } from './pages/NowPlaying';
import { Favorites } from './pages/Favorites';
interface AppProps {
  /** Which Three.js treatment drives the audio-reactive scene. */
  visualizerStyle?: 'vinyl' | 'particles';
  /** Show the large reactive scene in the Home hero. */
  showHeroVisualizer?: boolean;
  /** Audio-reactive room light behind the content. */
  ambientBackdrop?: boolean;
}
interface ShellProps {
  visualizerStyle: 'vinyl' | 'particles';
  showHeroVisualizer: boolean;
}
function Shell({
  visualizerStyle,
  showHeroVisualizer
}: ShellProps) {
  const location = useLocation();
  useSeedPlaylists();
  return <AnimatePresence mode="wait" initial={false} data-id="element-0" data-mp="2zmenc70qri6z">
      <PageTransition key={location.pathname} data-id="element-1" data-mp="33morde4z3yj7">
        <Routes location={location} data-id="element-2" data-mp="33ngfy505kvzz">
          <Route path="/" element={<Home visualizerStyle={visualizerStyle} showHeroVisualizer={showHeroVisualizer} data-id="element-4" data-mp="38kqbm2e4y3w9" />} data-id="element-3" data-mp="33oi0r16z0wuw" />
          <Route path="/search" element={<Search data-id="element-6" data-mp="3dirtwl3qlz6o" />} data-id="element-5" data-mp="3dlnu6g324zya" />
          <Route path="/now-playing" element={<NowPlaying visualizerStyle={visualizerStyle} data-id="element-8" data-mp="nuhhkgf627t8" />} data-id="element-7" data-mp="nvj179a902mk" />
          <Route path="/favorites" element={<Favorites data-id="element-10" data-mp="stkm7zr8ic0o" />} data-id="element-9" data-mp="sunb624zy4dy" />
          <Route path="/library" element={<Library data-id="element-12" data-mp="36hwf6uoms18" />} data-id="element-11" data-mp="st2k4mhw53ku" />
          <Route path="/playlist/:id" element={<Playlist data-id="element-14" data-mp="34x3flo0nh5h" />} data-id="element-13" data-mp="35yngfn0fdzc" />
        </Routes>
      </PageTransition>
    </AnimatePresence>;
}
export function App({
  visualizerStyle = 'vinyl',
  showHeroVisualizer = true,
  ambientBackdrop = true
}: AppProps) {
  return <BrowserRouter data-id="element-15" data-mp="d2l6cyvrzuyq">
      <ThemeProvider data-id="element-16" data-mp="85ui3o9tht28">
        <LibraryProvider data-id="element-17" data-mp="85bd1859mz5m">
          <PlayerProvider data-id="element-18" data-mp="864b7kq5sgc5">
            <div className="relative flex h-full w-full flex-col overflow-hidden bg-ink-base" data-id="element-19" data-mp="83qhpgb4nc6p">
              {ambientBackdrop && <AmbientBackdrop data-id="element-20" data-mp="3bmbazg5gdtfn" />}
              <div className="relative flex min-h-0 flex-1" data-id="element-21" data-mp="3bncnzq614q00">
                <Sidebar data-id="element-22" data-mp="3qb7jfebf98gs" />
                <main className="scroll-thin min-w-0 flex-1 overflow-y-auto overflow-x-hidden overscroll-contain" data-id="element-23" data-mp="3qbfvj3zq09qx">
                  <Shell visualizerStyle={visualizerStyle} showHeroVisualizer={showHeroVisualizer} data-id="element-24" data-mp="3ljpigq9ef7vt" />
                </main>
              </div>
              <div className="relative" data-id="element-25" data-mp="2xsk4kgn0qpo5">
                <PlayerBar visualizerStyle={visualizerStyle} data-id="element-26" data-mp="2swlhcwdffdpb" />
                <MobileNav data-id="element-27" data-mp="18dri7slud9c8" />
              </div>
            </div>
          </PlayerProvider>
        </LibraryProvider>
      </ThemeProvider>
    </BrowserRouter>;
}